export const authRole = {
  Admin: ['ADMIN'],
  User: ['USER', 'ADMIN'],
};

export const defaultUser: any = {
  uid: 'john-alex',
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const allowMultiLanguage = import.meta.env.VITE_MULTILINGUAL === 'true';
// Penny (AI chatbot) is hidden when the env sets this to 'false'; shown by default.
export const allowAiChatbot = import.meta.env.VITE_AI_CHATBOT !== 'false';
export const fileStackKey = import.meta.env.VITE_FILESTACK_KEY as string;
export const FALLBACK_ROUTES = [
  { path: '/dashboards', permission: 'COMPANY.DASHBOARD.LIST' },
  { path: '/analytics', permission: 'COMPANY.ANALYTICS.LIST' },
  { path: '/companies', permission: 'COMPANY.COMPANIES.LIST' },
  { path: '/employees', permission: 'COMPANY.EMPLOYEES.LIST' },
  { path: '/timesheets', permission: 'COMPANY.TIMESHEETS.LIST' },
  { path: '/reports', permission: 'COMPANY.REPORTS.LIST' },
  { path: '/permissions', permission: 'COMPANY.PERMISSIONS.LIST' },
];

export const getInitialUrl = (): string => {
  try {
    const user = JSON.parse(localStorage.getItem('USER') || 'null');
    if (user?.roles === 'super_admin') return '/manage-account/admin';

    // An employee with onboarding outstanding is confined to it (see the
    // lockToOnboarding branch in AppRoutes), so land them there rather than
    // sending them to a dashboard they will only be bounced off.
    if (user?.roles === 'subcontractor' && user?.isOnboarding) {
      return '/onboarding';
    }

    const perms: string[] = JSON.parse(localStorage.getItem('PERMISSIONS') || '[]');
    if (perms.length) {
      const first = FALLBACK_ROUTES.find((r) => perms.includes(r.permission));
      if (first) return first.path;
    }
  } catch {
    // ignore
  }
  return '/dashboards';
};

export const initialUrl = '/dashboards'; // fallback constant

export const USCTiers = [
  { value: 'STANDARD', label: 'Apply standard USC cut off point values' },
  { value: 'USE1', label: 'Use 1 cut off point' },
  { value: 'USE2', label: 'Use 2 cut off point' },
  { value: 'USE3', label: 'Use 3 cut off point' },
];

export const CODE_RATE_HOLIDAY = 'PRHP';
export const CODE_RATE_HOLIDAY_LEAVER = 'PRHPL';
export const CODE_RATE_HOLIDAY_ER_COSTS_LEAVER = 'PRHPERL';
export const CODE_RATE_PENSION_REFUND_LEAVER = 'PRPRFL';
export const CODE_RATE_PENSION_REFUND_ER_LEAVER = 'PRPRFERL';
export const HP_CODES = [
  CODE_RATE_HOLIDAY,
  CODE_RATE_HOLIDAY_LEAVER,
  CODE_RATE_HOLIDAY_ER_COSTS_LEAVER,
];
export const PENSION_CODES = [
  CODE_RATE_PENSION_REFUND_LEAVER,
  CODE_RATE_PENSION_REFUND_ER_LEAVER,
];
export const LEAVER_CODES = [
  CODE_RATE_HOLIDAY_LEAVER,
  CODE_RATE_HOLIDAY_ER_COSTS_LEAVER,
  CODE_RATE_PENSION_REFUND_LEAVER,
  CODE_RATE_PENSION_REFUND_ER_LEAVER,
];
export const IGNORE_CODES = [...HP_CODES, ...PENSION_CODES];

export const UMBRELLA_PAYE_HYBRID = [
  'UMBRELLA',
  'PAYEE',
  'HYBRID',
  'PAYE_HYBRID',
  'PAYE_FTH',
];

export const UMBRELLA_PAYE = ['UMBRELLA', 'PAYEE', 'PAYE_FTH'];

export const defaultPensionCalCulationMethodOptions = [
  { label: 'Net Pay Arrangement', value: 'NET_PAY_ARRANGEMENT' },
  { label: 'Relief at Source', value: 'RELIEF_AT_SOURCE' },
];

export const industryTypeOptions = [
  { label: 'Agriculture', value: 'AGRICULTURE' },
  { label: 'Fisheries & Aquaculture', value: 'FISHERIES_AQUACULTURE' },
  { label: 'Road Transport', value: 'ROAD_TRANSPORT' },
];

export const followingOptions = [
  {
    label: 'Other',
    value: 'OTHER',
    desc: 'Any business involved in economic activity that is not listed above',
  },
  {
    label: 'State aid rules do not apply to this business',
    value: 'NOT_APPLY',
    desc: 'For example, a charity or community sports club',
  },
];

export const BUREAU_PAYSLIP_TEMPLATES = [
  { label: 'Nxsys Default', value: 'DEFAULT' },
  { label: 'Layout 1', value: 'LAYOUT_1' }, // old
  { label: 'Layout 2', value: 'LAYOUT_2' }, // new
  { label: 'Layout 3', value: 'LAYOUT_3' }, // revert page number
];

export const autoEnrolmentSchemeTypeIrelandOptions = [
  {
    label:
      'The National Automatic Enrolment Retirement Savings Authority (NAERSA)',
    value: 'NAERSA',
  },
];

export const privatePensionSchemeTypeOptions = [
  { label: 'Personal Retirement Savings Account (PRSA)', value: 'PRSA' },
  { label: 'Retirement Benefit Scheme (RBS)', value: 'RBS' },
  { label: 'Retirement Annuity Contract (RAC)', value: 'RAC' },
  { label: 'Pan-European Personal Pension Product (PEPP)', value: 'PEPP' },
];
